// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"33f1cde1","505":"193e149a","846":"0a79310f"}[chunkId] + ".chunk.css";
};